import { render, staticRenderFns } from "./AGB.vue?vue&type=template&id=da953470&scoped=true&"
var script = {}
import style0 from "./AGB.vue?vue&type=style&index=0&id=da953470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da953470",
  null
  
)

export default component.exports